import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: 'Home', href: '/' },
  { label: 'Pipeline', href: '/pipeline' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-700 ease-silk ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-xl border-b border-primary-500/10'
          : 'bg-transparent'
      }`}
    >
      <div className="flex items-center justify-between px-6 md:px-12 lg:px-20 py-5 md:py-6">
        <Link to="/" className="flex items-center group">
          <img
            src="https://public.readdy.ai/ai/img_res/2cb5aff4-b041-402b-9d46-8212e5415995.png"
            alt="VOXEA"
            className="h-[80px] w-auto object-contain"
          />
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className={`font-body text-sm tracking-wide transition-colors duration-500 ease-silk relative group ${
                location.pathname === link.href
                  ? 'text-primary-500'
                  : 'text-foreground-400 hover:text-foreground-50'
              }`}
            >
              {link.label}
              <span
                className={`absolute -bottom-1 left-0 h-px bg-primary-500 transition-all duration-500 ease-silk ${
                  location.pathname === link.href ? 'w-full' : 'w-0 group-hover:w-full'
                }`}
              />
            </Link>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-4">
          <Link
            to="/contact"
            className="px-5 py-2.5 bg-primary-500/10 hover:bg-primary-500/20 border border-primary-500/40 hover:border-primary-500 text-primary-500 font-body text-sm font-medium rounded-full transition-all duration-500 ease-silk whitespace-nowrap"
          >
            Get in Touch
          </Link>
        </div>

        <button
          type="button"
          className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-50 cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <i className={`${menuOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl`} />
        </button>
      </div>

      <div
        className={`md:hidden transition-all duration-700 ease-silk overflow-hidden ${
          menuOpen ? 'max-h-64 opacity-100' : 'max-h-0 opacity-0'
        } bg-background-100/98 backdrop-blur-xl border-b border-primary-500/10`}
      >
        <nav className="flex flex-col px-6 py-4 gap-4">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className={`font-body text-base py-2 transition-colors duration-500 ease-silk ${
                location.pathname === link.href
                  ? 'text-primary-500'
                  : 'text-foreground-400'
              }`}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/contact"
            className="mt-2 px-5 py-3 bg-primary-500/10 border border-primary-500/40 text-primary-500 font-body text-sm font-medium rounded-full text-center whitespace-nowrap"
          >
            Get in Touch
          </Link>
        </nav>
      </div>
    </header>
  );
}